import React from "react";
import { Trans } from "react-i18next";

import { Button, Callout, Switch } from "@blueprintjs/core";
import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../utils/AuthenticatedFetch";
import { mefCountry } from "../../../utils/mef";

function arraymove(arr, fromIndex, toIndex) {
  var element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
}

export default class CountryPriority extends React.Component {
  constructor() {
    super();
    this.state = {
      selected: [],
      available: [],
    };
  }

  ac = new AbortController();

  componentDidMount() {
    authenticatedGetFetch("/ow/dc/settings/countries?srv=" + this.props.srv, (res) => {
      this.setState({
        selected: res?.selected || [],
        available: res?.available || [],
      });
    });
  }

  update() {
    authenticatedPostFetch("/ow/dc/settings/countries?srv=" + this.props.srv, this.state.selected);
  }

  render() {
    const res = [];

    this.state.available.sort();

    let id = 0;
    for (let s of this.state.selected) {
      res.push(
        <div key={"cnt"+s}>
          <Switch
            inline={true}
            defaultChecked={true}
            readOnly={true}
            onClick={() =>
              this.setState(
                {
                  available: [
                    ...this.state.available,
                    this.state.selected.splice(
                      this.state.selected.indexOf(s),
                      1
                    ),
                  ],
                },
                () => this.update()
              )
            }
          />
          <Button
            icon="caret-up"
            minimal={true}
            disabled={id <= 0}
            onClick={() => {
              this.setState(
                {
                  selected: arraymove(
                    this.state.selected,
                    this.state.selected.indexOf(s),
                    this.state.selected.indexOf(s) - 1
                  ),
                },
                () => this.update()
              );
            }}
          />
          <Button
            icon="caret-down"
            minimal={true}
            disabled={id >= this.state.selected.length - 1}
            onClick={() => {
              this.setState(
                {
                  selected: arraymove(
                    this.state.selected,
                    this.state.selected.indexOf(s),
                    this.state.selected.indexOf(s) + 1
                  ),
                },
                () => this.update()
              );
            }}
          />
          {mefCountry(s)}
        </div>
      );
      id++;
    }

    for (let a of this.state.available) {
      res.push(
        <div key={"cnt"+a}>
          <Switch
            inline={true}
            defaultChecked={false}
            readOnly={true}
            onClick={() => {
              this.setState(
                {
                  selected: [
                    ...this.state.selected,
                    ...this.state.available.splice(
                      this.state.available.indexOf(a),
                      1
                    ),
                  ],
                },
                () => this.update()
              );
            }}
          />
          <Button icon="caret-up" disabled={true} minimal={true} />
          <Button icon="caret-down" disabled={true} minimal={true} />
          {mefCountry(a)}
        </div>
      );
    }

    return (
      <Callout title={<Trans>country priority</Trans>}>
        {res}
      </Callout>
    );
  }
}
